import { render, staticRenderFns } from "./ExerciseSolutionForm.vue?vue&type=template&id=7412b425"
import script from "./ExerciseSolutionForm.vue?vue&type=script&lang=js"
export * from "./ExerciseSolutionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports